




























































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { FeeSheetRuleService } from '../../service/FeeSheetRuleService';
import { AgentService } from '../../service/AgentService';
import { ClientService } from '../../service/ClientService';
import { CountryService } from '../../service/CountryService';
import { CurrencyService } from '../../service/CurrencyService';
import { DataGrid } from '@questelservices/common-vue';
import {
  DxColumn,
  DxEditing,
  DxForm,
  DxFormItem,
  DxHeaderFilter,
  DxLookup,
  DxPopup
} from 'devextreme-vue/data-grid';
import { DxItem, DxGroupItem, DxButtonItem } from 'devextreme-vue/form';
import { DxSelectBox, DxButton, DxTextBox, DxCheckBox } from 'devextreme-vue';
import DevExpress from 'devextreme/bundles/dx.all';
import CustomStore from 'devextreme/data/custom_store';
import { FeeSheetRuleDto } from '../../models/Fees/FeeSheetRuleDto';
import { PhaseTypeDto } from '../../models/PhaseTypeDto';
import { FilingTypeDto } from '../../models/FilingTypeDto';
import { FilingTypeService } from '../../service/FilingTypeService';
import { QuestelServicesClient } from '@questelservices/common';
import DateTime from '../../utilities/DateTime';
import _ from 'lodash';

@Component({
  components: {
    DxSelectBox,
    DataGrid,
    DxColumn,
    DxEditing,
    DxForm,
    DxFormItem,
    DxHeaderFilter,
    DxItem,
    DxGroupItem,
    DxButtonItem,
    DxLookup,
    DxPopup,
    DxButton,
    DxTextBox,
    DxCheckBox
  }
})
export default class FeeSheetRulesGrid extends Vue {
  clients: Array<{ text: string; value: Guid }> = [];
  agents: Array<{ text: string; value: Guid }> = [];
  countries: Array<{ text: string; value: string }> = [];
  currencies: Array<{ text: string; value: string }> = [];
  phaseTypes: Array<{ text: string; value: string }> = [];
  filingTypes: Array<{ text: string; value: string }> = [];
  dataGrid: any;

  jurisdictionOptions: Array<{ text: string; value: boolean }> = [
    { text: 'In', value: true },
    { text: 'Out', value: false },
  ]

  feeSheetRuleCustomStoreOptions: DevExpress.data.CustomStoreOptions;
  feeSheetRuleService: FeeSheetRuleService;

  constructor() {
    super();

    this.feeSheetRuleService = new FeeSheetRuleService('/api/FeeSheetRules');

    this.loadData();

    this.feeSheetRuleCustomStoreOptions = {
      key: 'FeeSheetRuleId',
      load: loadOptions => this.feeSheetRuleService.search(loadOptions).catch(result => {
        if (!result.Success) {
          throw Error(result.Message);
        }

        return result;
      }),
      insert: values => this.feeSheetRuleService.create(values).catch(result => {
        if (!result.Success) {
          throw Error(result.Message);
        }

        return result;
      }),
      update: (key, values) => this.feeSheetRuleService.edit(key, values).catch(result => {
        if (!result.Success) {
          throw Error(result.Message);
        }

        return result;
      }),
      remove: key => this.feeSheetRuleService.delete(key).catch(result => {
        if (!result.Success) {
          throw Error(result.Message);
        }

        return result;
      })
    };
  }

  async loadData() {
    let clientService = new ClientService();
    let clients = await clientService.getAll();
    this.clients = clients.map(c => {
      return { text: c.ClientName, value: c.ClientId };
    });
    this.clients.unshift({ text: 'ALL', value: '' });

    let agentService = new AgentService();
    let agents = await agentService.getAll();
    this.agents = agents.map(a => {
      return { text: a.AgentName, value: a.AgentId };
    });
    this.agents.unshift({ text: 'ALL', value: '' });

    let countryService = new CountryService();
    let countries = await countryService.getAll();
    this.countries = countries.map((c: any) => {      
      return { text: c.CountryCode, value: c.CountryId };
    });
    this.countries.unshift({ text: 'ALL', value: '' });

    let currencyService = new CurrencyService();
    let currencies = await currencyService.getAll();
    this.currencies = currencies.map((curr: any) => {
      return { text: curr.CurrencyCode, value: curr.CurrencyId };
    });

    let serviceClient = new QuestelServicesClient(this.$store, '');
    let phaseTypes = await serviceClient.get<PhaseTypeDto[]>('/api/phasetype/all');
    this.phaseTypes = phaseTypes.map((p: any) => {
      return { text: p.PhaseName, value: p.PhaseTypeId };
    });

    let filingTypeService = new FilingTypeService();
    filingTypeService.getTypes().then(types => {
      this.filingTypes = types.map((type: any) => {
        return { text: type.Name, value: type.FilingTypeId };
      });
      this.filingTypes.unshift({ text: 'ALL', value: '' });
    });
  }

  popupShowing(e: any) {
    let toolbarItems = e.component.option('toolbarItems');
    toolbarItems[0].options.stylingMode = 'contained';
    toolbarItems[1].options.stylingMode = 'contained';
    toolbarItems[1].options.type = 'normal';
    e.component.option('toolbarItems', toolbarItems);
  }

  editingStart(e: any) {
    if (e.data.CountryId == null) {
      e.data.CountryId = '';
    }

    if (e.data.ClientId == null) {
      e.data.ClientId = '';
    }

    if (e.data.FilingTypeId == null) {
      e.data.FilingTypeId = '';
    }

    if (e.data.Agent == null) {
      e.data.Agent = {
        AgentId: '',
        AgentName: ''
      };
    } else if (e.data.Agent.AgentId == null) {
      e.data.Agent.AgentId = '';
    }
  }

  rowUpdating(e: any) {
    e.newData = _.merge({}, e.oldData, e.newData);

    if (e.newData.Agent.AgentId === '') {
      e.newData.Agent.AgentId = '00000000-0000-0000-0000-000000000000';
    }
  }

  dataGridInitialized(e: any) {
    this.dataGrid = e.component;
  }

  saveEditData() {
    if (this.dataGrid) {
      this.dataGrid.focus();
      this.dataGrid.saveEditData();
    }
  }

  customizeNullText(info: any) {
    return info.valueText === '' ? 'ALL' : info.valueText;
  }
}
